import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { ChevronLeftIcon } from '@/src/components/icon/stroke/ChevronLeftIcon';
import { ChevronRightIcon } from '@/src/components/icon/stroke/ChevronRightIcon';
import { ChevronDownIcon } from '@/src/components/icon/stroke/ChevronDownIcon';
import { getInteractiveStyle } from '@/src/materialui/button/interactive';
import { getFocusRingStyle } from '@/src/components/focusring';
import { getTypography } from '@/src/materialui/typography/typography.theme';
import { FlowPickersCalendarHeader } from './PickersCalendarHeader';

// style for various buttons in calendars (day, month, year)
export const flowPickersItemStyle = (theme: Theme) => ({
  transition:
    'transform 0.3s ease-out, color 0.3s ease-out, background-color 0.3s ease-out, border-color 0.3s ease-out, box-shadow 0.3s ease-out, opacity 0.3s ease-out',
  ...getFocusRingStyle(theme, true, 1, ':focus-visible'),
  border: '1px solid transparent',
  [theme.breakpoints.up('xs')]: {
    // switch to 'medium body' typography according to figma
    ...getTypography('body', theme.direction === 'rtl', 'medium'),
  },
  '&:not(.Mui-selected)': {
    // hover
    ...getInteractiveStyle(
      {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: theme.palette.text.primary,
      },
      {
        borderColor: theme.palette.surface.primary,
        backgroundColor: theme.palette.surface.primary,
        color: theme.palette.text.primary,
      },
      undefined,
      undefined,
      ':focus-visible',
    ),
    // disabled
    '&.Mui-disabled': {
      color: theme.palette.disabled.primary,
    },
  },
  // selected
  '&.Mui-selected': {
    '&, &:hover, &:focus': {
      fontWeight: '300',
      borderColor: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
      color: theme.palette.background.primary,
    },
  },
});

export const flowDateCalendar: Components<Theme>['MuiDateCalendar'] = {
  defaultProps: {
    slots: {
      leftArrowIcon: ChevronLeftIcon,
      rightArrowIcon: ChevronRightIcon,
      switchViewIcon: ChevronDownIcon,
      calendarHeader: FlowPickersCalendarHeader,
    },
    slotProps: {
      nextIconButton: {
        size: 'small',
      },
      previousIconButton: {
        size: 'small',
      },
      switchViewButton: {
        size: 'small',
      },
    },
    views: ['year', 'month', 'day'],
  },
  styleOverrides: {
    root: {
      // width of whole calendar, increased from 320px, affects mobiledatepicker.theme
      width: '360px',
      // height calculated on largest possible month, affects monthcalendar.theme
      height: '400px',
      maxHeight: '400px',
      // correct time height in DateTime field
      '& ~ .MuiMultiSectionDigitalClock-root.MuiMultiSectionDigitalClock-root': {
        '&, & .MuiMultiSectionDigitalClockSection-root': {
          maxHeight: '400px',
        },
      },
    },
  },
};
